import gql from 'graphql-tag';

import lessonExerciseFragment from './lesson-exercise-fragment';

export default gql`
  query findByIdLessonExerciseQuery($_id: MongoID!) {
    findByIdLessonExerciseQuery(_id: $_id) {
      ...LessonExerciseFragment
    }
  }
  ${lessonExerciseFragment}
`;
